import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { draftDatesFromSearch } from "@/features/MarketingCalendar/planEvent/draft";
import { PlanEventWizard } from "@/features/MarketingCalendar/planEvent/PlanEventWizard";

// Prefill dates from a calendar click/drag-select; junk falls back to none.
const dateParam = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);
const planEventSearchSchema = z.object({
  start: dateParam,
  end: dateParam,
  /** Month ("YYYY-MM") the calendar was on: exits without a campaign land
   * back there instead of snapping to today (FOG-2538). */
  month: z.string().optional().catch(undefined),
  /** Broadcast just created by the BroadcastV2 composer (returnTo flow). */
  addedBroadcastId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/marketing-calendar/$siteId/new")({
  component: RouteComponent,
  validateSearch: zodValidator(planEventSearchSchema),
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const { start, end, month, addedBroadcastId } = Route.useSearch();
  // The wizard renders the page header itself so the step's Back/Continue
  // actions can live in it (prototype layout).
  return (
    <PlanEventWizard
      siteId={siteId}
      initialDraft={draftDatesFromSearch(start, end)}
      returnMonth={month}
      addedBroadcastId={addedBroadcastId}
    />
  );
}
